import React, {useEffect, useState} from "react";


const PreviewImg = ({selectedItem, currentColor, type}) => {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, [selectedItem]);

  const renderImage = () => {
    if (type !== "PART") return null;

    if (!selectedItem) return null;

    if (hasError) {
      return (
        <div className="image-fallback font-sm">
          <div>No<br/>Image</div>
        </div>
      );
    }

    return (
      <img
        src={`${process.env.REACT_APP_image_path}/item/${selectedItem.thumbnailImg}`}
        alt="Preview Thumbnail"
        onError={() => {
          setHasError(true);
        }}
      />
    );
  };


  return (
    <div className="option-value-thumb">
      <div className="thumb" style={currentColor && {backgroundColor: `rgba(${currentColor && currentColor.COLOR})`}}>
        {renderImage()}
      </div>
      {/*<div className={`${currentColor && currentColor.MATERIAL === "GLOSSY" ? "material-glossy": ''}`}></div>*/}
    </div>
  )
}

export default PreviewImg;
